const API_URL = `${window.location.origin}/apps/api/`; // TODO: change to /api/ for production

import { WDJSErrorHandler } from 'wd-js-error-handler';

class wdJobPage extends HTMLElement {
    static selectors = {
        form: '.wd-job-page-form_fields',
        fileInput: '.wd-job-page-form input[type="file"]',
        phoneInput: '#phone',
        emailInput: '#email',
        labelText: '.wd-job-page-form .wd-job-page-form_resume_label p',
        submitButton: '.wd-job-page-form button',
        shareButton: '.wd-job-page-share_button',
        jobTitle: '.wd-job-page_title',
        jobBody: '.wd-job-page-body',
        message: 'span.success_or_error_message',
    }
    constructor() {
        super();
        this.errHandler = new WDJSErrorHandler();
        this.init();
    }
    init() {
        this.attachEventListeners();
        this.querySelector(wdJobPage.selectors.labelText).parentElement.classList.remove("blocked")

        // check if job data is already in session storage
        if (sessionStorage.getItem('job')) {
            const jobCode = new URLSearchParams(window.location.search).get('jobCode'),
                sessionJob = JSON.parse(sessionStorage.getItem('job'));
            // if job code matches the session job code, render the job data
            if (jobCode == sessionJob.id) {
                this.renderJobData(sessionJob);
            }
        }
        // regardless, fetch data from API
        this.renderJobData();
    }
    attachEventListeners() {
        const form = this.querySelector(wdJobPage.selectors.form);
        const fileInput = this.querySelector(wdJobPage.selectors.fileInput);
        const phoneInput = this.querySelector(wdJobPage.selectors.phoneInput);
        const emailInput = this.querySelector(wdJobPage.selectors.emailInput);
        const submitButton = this.querySelector(wdJobPage.selectors.submitButton);
        const shareButton = this.querySelector(wdJobPage.selectors.shareButton);

        if (fileInput) {
            fileInput.addEventListener('change', (event) => {
                const labelText = this.querySelector(wdJobPage.selectors.labelText);
                if (event.target.files.length > 0) {
                    this.updateSubmitButtonState(undefined, "שליחת פרטים");
                    labelText.textContent = event.target.files[0].name;
                    this.updateMessage(true, "") // reset older message allowing submitting again
                    const phoneValue = phoneInput?.value.trim();
                    const emailValue = emailInput?.value.trim();
                    if (!phoneValue || !emailValue) {
                        this.handlePdfUpload(event.target.files[0]);
                    }
                } else {
                    this.updateSubmitButtonState(undefined, "שליחת פרטים");
                    labelText.textContent = 'הוספת קורות חיים';
                }
            });
        }

        this.querySelectorAll("input").forEach(input => {
            input.addEventListener('input', () => {
                this.isFromValid();
            });
        });

        if (form) {
            form.addEventListener('submit', (event) => {
                event.preventDefault();
                if (!form.reportValidity()) {
                    return;
                }
                this.handleSubmit(fileInput, submitButton);
            });
        }

        if (shareButton) {
            shareButton.addEventListener('click', (event) => {
                event.preventDefault();
                this.handleShare();
            });
        }
    }

    /** get & render data from session storage or fetch from API;
     *  optionally using session sotrage data for faster loads **/
    async renderJobData(data = null) {
        const jobData = data || await this.fetchJobData();
        if (jobData) {
            const jobTitleElement = this.querySelector(wdJobPage.selectors.jobTitle);
            const jobBodyElement = this.querySelector(wdJobPage.selectors.jobBody);
            if (jobTitleElement) {
                jobTitleElement.textContent = jobData.title || 'No Title';
            }
            if (jobBodyElement && !data) {
                jobBodyElement.innerHTML = jobData.description.trim().replace(/\n+/g, '<br>')
                    || 'No Description';
            }
        }
    }

    /** attempt extracting data from pdf **/
    async handlePdfUpload(file) {
        const phoneInput = this.querySelector(wdJobPage.selectors.phoneInput);
        const emailInput = this.querySelector(wdJobPage.selectors.emailInput);
        const phoneIsEmpty = phoneInput && !phoneInput.value.trim();
        const emailIsEmpty = emailInput && !emailInput.value.trim();

        // if both phone and email are not empty, return
        if (!phoneIsEmpty && !emailIsEmpty) {
            return;
        }

        pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.6.347/pdf.worker.min.js';

        const arrayBuffer = await file.arrayBuffer();
        const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise;

        // convert pdf to normalized text
        let pdfText = '';
        for (let i = 1; i <= pdf.numPages; i++) {
            const page = await pdf.getPage(i);
            const content = await page.getTextContent();
            pdfText += content.items
                .map(_ => _.str.trim() || "\n")
                .join(" ")
                .replaceAll(/(\n( )*)+/g, "\n")
                .replaceAll(/( )+/g, " ")
        }

        /** Extract first likely phone number from text. */
        const extractPhone = (pdfText) => {
            const re =
                /(?=(?:\D*\d){10,})(?:(?:\+|00)\d{1,3}[\s.-]*)?(?:\(?\d{2,4}\)?[\s.-]*)?\d(?:[\s.-]*\d){8,}/g;
            const matches = pdfText.match(re) || [];
            return matches[0]?.replaceAll(" - ", "") || null;
        };

        /** Extract first email from text. */
        const extractEmail = (pdfText) => {
            const re = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i;
            const match = pdfText.match(re);
            return match ? match[0] : null;
        };

        const phone = extractPhone(pdfText);
        const email = extractEmail(pdfText);

        // if email input is empty, fill it with the extracted email
        if (emailIsEmpty && email && emailInput)
            emailInput.value = email;

        // if phone input is empty, fill it with the extracted phone
        if (phoneIsEmpty && phone && phoneInput)
            phoneInput.value = phone;

    }

    async handleShare() {
        const shareData = {
            title: document.title,
            text: 'Check out this job posting!',
            url: window.location.href
        };

        if (navigator.share) {
            try {
                await navigator.share(shareData);
            } catch (error) {
                console.error('Error sharing:', error);
            }
        } else if (navigator.clipboard) {
            try {
                await navigator.clipboard.writeText(window.location.href);
            } catch (err) {
                alert('Sharing not supported on this browser. Please copy the URL manually.');
            }
        } else {
            alert('Sharing not supported on this browser. Please copy the URL manually.');
        }
    }
    async fetchJobData() {
        try {
            const jobCode = new URLSearchParams(window.location.search).get('jobCode');
            const response = await fetch(`${API_URL}career/${jobCode}`);
            const data = await response.json();
            if (response.ok && data.success) {
                return data.data;
            }
            return null;
        } catch (error) {
            console.error("Error fetching job data:", error);
            return null;
        }
    }
    async handleSubmit(fileInput, submitButton) {
        this.updateMessage(false, "");

        //make sure file type is pdf or docx
        const messageElement = this.querySelector(wdJobPage.selectors.message);
        const phoneInput = this.querySelector(wdJobPage.selectors.phoneInput);
        const emailInput = this.querySelector(wdJobPage.selectors.emailInput);
        if (fileInput.files.length === 0) {
            this.updateMessage(false, this.errHandler.frontendError("NoFileSelected"));
            return;
        }
        const file = fileInput.files[0];
        if (file && !['application/pdf', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'].includes(file.type)) {
            this.updateMessage(false, this.errHandler.frontendError("MustBePDFOrDOCX"));
            return;
        }
        this.updateSubmitButtonState(false, "פרטים נשלחים...");

        const formData = new FormData();
        formData.append('resume', fileInput.files[0]);
        formData.append('phone', phoneInput?.value.trim() || "");
        formData.append('email', emailInput?.value.trim() || "");
        const mockCheckbox = document.getElementById('mockData');
        formData.append('mock', mockCheckbox ? mockCheckbox.checked : false);
        const jobId = new URLSearchParams(window.location.search).get('jobCode');

        try {
            const response = await fetch(`${API_URL}career/candidacy/${jobId}`, {
                method: 'POST',
                body: formData
            });
            const data = await response.json();
            if (response.ok && data.success) {
                this.updateSubmitButtonState(false, "פרטים נשלחו");
                this.updateMessage(true, 'קורות החיים נשלחו בהצלחה');
                // Reset form fields for a clean state after success.
                const form = this.querySelector(wdJobPage.selectors.form);
                if (form) {
                    form.reset();
                }
                const labelText = this.querySelector(wdJobPage.selectors.labelText);
                if (labelText) {
                    labelText.textContent = 'הוספת קורות חיים';
                }
            } else {
                this.updateSubmitButtonState(true, 'שליחת פרטים');

                const errorMessage = this.errHandler.frontendError(data.message[0]);
                if (response.status === 400 && errorMessage) {
                    this.updateMessage(false, errorMessage);
                } else if (response.status === 400 && data.message[0] && data.message[0].includes('expected size is less than')) {
                    this.updateMessage(false, this.errHandler.frontendError("FileTooLarge"));
                } else {
                    throw new Error(data.message[0] || "UnknownErrorAtApply");
                }
            }
        } catch (error) {
            console.error("Error submitting resume to application:", error);
            this.updateSubmitButtonState(true, 'שליחת פרטים');
            this.updateMessage(false, this.errHandler.frontendError("UnknownErrorAtApply"));
        }
    }
    updateMessage(isSuccess = false, text = "") {

        const messageElement = this.querySelector(wdJobPage.selectors.message);
        if (text) {
            messageElement.textContent = text;
            if (isSuccess) {
                messageElement.classList.add('success');
                messageElement.classList.remove('err');
            } else {
                messageElement.classList.add('err');
                messageElement.classList.remove('success');
            }
            messageElement.style.display = 'block';
        } else {
            messageElement.style.display = 'none';
            messageElement.textContent = "";
            messageElement.classList.remove('err', 'success');
        }
    }

    isFromValid() {
        const form = this.querySelector(wdJobPage.selectors.form);
        this.updateSubmitButtonState(form.checkValidity());
    }

    updateSubmitButtonState(isEnabled, text = "שליחת פרטים") {
        const submitButton = this.querySelector(wdJobPage.selectors.submitButton);
        if (text !== undefined)
            submitButton.querySelector('span').textContent = text;
        if (isEnabled !== undefined) {
            if (isEnabled) {
                submitButton.classList.remove('disabled');
                submitButton.removeAttribute('disabled');
            } else {
                submitButton.classList.add('disabled');
                submitButton.setAttribute('disabled', 'disabled');
            }
        }
    }

}
window.addEventListener('load', () => {
    customElements.define('wd-job-page', wdJobPage);
});
